import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=46c730b5&"
import script from "./Company.vue?vue&type=script&async=true&defer=true&lang=js&"
export * from "./Company.vue?vue&type=script&async=true&defer=true&lang=js&"
import style0 from "./Company.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports